import React, { PureComponent } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useIsMobileWidth, useIsTabletWidth } from "@src/utils/mediaQuery";

const PieChartLib = ({ data, arc = false, hideTooltips = false }) => {
  const isMobile = useIsMobileWidth();
  const isTablet = useIsTabletWidth();
  const startAngle = arc ? 180 : 90;
  let innerRadius = arc ? 95 : 0;
  const endAngle = arc ? 0 : -270;
  const height = arc ? 140 : 100;
  let width = arc ? 250 : 100;
  let outerRadius = arc ? 120 : 50;
  const yPosition = arc ? "90%" : "50%";

  // Handle middle case between mobile and desktop
  //if (arc && window.innerWidth >= 768 && window.innerWidth <= 830) {
  if (arc && isTablet && !isMobile) {
    width = 200;
    innerRadius = 85;
    outerRadius = 100;
  }

  return (
    // <ResponsiveContainer width={width + 20} height={height + 20}>
    <PieChart width={width} height={height} style={{ zIndex: 10 }}>
      <Pie
        data={data}
        cx="50%"
        cy={yPosition}
        labelLine={false}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        dataKey="value"
        startAngle={startAngle}
        endAngle={endAngle}
        isAnimationActive={false}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.colour} />
        ))}
      </Pie>
      {hideTooltips !== true && <Tooltip />}
    </PieChart>
    // </ResponsiveContainer>
  );
};
export default PieChartLib;
